/* eslint-disable class-methods-use-this */
export default class TabMenu {
    constructor(domElement) {
        if(domElement.getAttribute('data-tab-menu-initialized') && domElement.getAttribute('data-tab-menu-initialized') === 'true') {
            throw new Error('Module already initialized');
        }

        domElement.dataset.tabMenuInitialized = 'true';

        this.element = domElement;
        this.content = this.element.querySelector('[data-tab-menu-content]');
        this.tabs = [...this.element.querySelectorAll('[data-tab-menu-item]')];
        this.tabPanes = [...this.element.querySelectorAll('[data-tab-menu-pane]')];
        this.select = this.element.querySelector('[data-tab-menu-select]');

        this.initEvents();
    }

    initEvents() {
        this.tabs.forEach(tab => {
            tab.addEventListener('click', this.handleTabClick.bind(this));
        });

        if(this.select) {
            this.select.addEventListener('change', this.handleSelectChange.bind(this));
        }
    }

    handleTabClick(evt) {
        const tab = evt.currentTarget;
        const tabKey = tab.getAttribute('data-tab-menu-item');
        this.render(tabKey);
    }

    handleSelectChange() {
        const key = this.select.children[this.select.selectedIndex].value;

        this.render(key);
    }

    hideVisibleTabPanes() {
        this.removeClassNameFromElements(this.tabPanes, 'tab-menu__content__pane--visible');
    }

    showTabPane(key) {
        this.findElementByAttribute(this.tabPanes, 'data-tab-menu-pane', key)
            .classList
            .add('tab-menu__content__pane--visible');
    }

    clearActiveTab() {
        this.removeClassNameFromElements(this.tabs, 'tab--active');
    }

    setActiveTab(key) {
        this.findElementByAttribute(this.tabs, 'data-tab-menu-item', key)
            .classList
            .add('tab--active');
    }

    removeClassNameFromElements(elements, className) {
        elements.forEach(element => element.classList.remove(className));
    }

    findElementByAttribute(collection, attr, value) {
        return collection.find(element => element.getAttribute(attr) === value);
    }

    setSelectIndex(key) {
        const tab = this.tabs.find(domElement => domElement.getAttribute('data-tab-menu-item') === key);
        const index = this.tabs.findIndex(item => item === tab);
        this.select.selectedIndex = index;
    }

    render(key) {
        this.hideVisibleTabPanes();
        this.showTabPane(key);
        this.clearActiveTab();
        this.setActiveTab(key);

        if(this.select) {
            this.setSelectIndex(key);
        }
    }
}
